import { Textarea, TextInput } from '@mantine/core';
import React from 'react';

const SalesTermsRemarks = ({ field = [], values = {}, changeHandler = () => { } }) => {
  const validFields = Array.isArray(field) ? field : [];

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', width: '70%' }}>
      {validFields.map((field) => (
        <Textarea
          key={field.name}
          label={field.label}
          value={values[field.name] || ''}
          readOnly={field.readOnly !== false}
          variant={field.variant || 'filled'}
          multiline={field.multiline}
          styles={{ input: { height: field.height || '100px' } }}
          mt={field.marginTop || 'sm'}
          onChange={(event) => changeHandler(event, field.name)}
          placeholder={field.placeholder}
        />
      ))}
    </div>
  );
};

export default SalesTermsRemarks;
